import { call, put, takeLatest } from "redux-saga/effects";
import { setIsLoading } from "../../Containers/App/action";
import { setPostData } from "../../Containers/PostContainer/action";
import { exploreSearch } from "../../Domain/api";
import { setUserFound } from "./action";
import { SEARCH } from "./constants";

export function* doSearch({q}) {
    try {
        yield put(setIsLoading(true));
        const result = yield call(exploreSearch, q);
        yield put(setUserFound(result.users));
        yield put(setPostData(result.posts));
        yield put(setIsLoading(false));
    } catch (error) {
        return;
    }
} 

export default function* exploreSaga() {
    yield takeLatest(SEARCH, doSearch);
}